export const RoomMaxLength = 50;
export const RoomPattern = /^\d{1,5}([А-ЯІЇЄҐ])?((([-\d]{1,4}.*)|[\/][А-ЯІЇЄҐ\d]{1,4})|[А-ЯІЇЄҐ]{0,3})$/u;
export const RoomControlName = 'room';
export const RoomLabel = 'Квартира';
export const RoomPlaceholder = 'Квартира';
export const RoomClasses = 'form-col w-20';
